import React, { useContext, useEffect } from 'react';
import { store } from '../../Helper/Context/Store';
const PlaceSearch = ({ apiKey }) => {
    const { setmapPostitionMarkerLat, setmapPostitionMarkerLang, setMapAddress } = useContext(store);
    useEffect(() => {
        // Initialize Google Places Autocomplete when the component mounts
        function initAutocomplete() {
            const input = document.getElementById('location-input')
            const autocomplete = new window.google.maps.places.Autocomplete(input, {
                componentRestrictions: { country: 'in' } // Restrict results to India
            });

            // Optional: Add event listener to handle place selection
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                // console.log(place.address_components.filter((items) => items.types == "postal_code")[0].long_name)
                // console.log(place.address_components.filter((code) => code.types == 'postal_code'))
                setmapPostitionMarkerLat(place.geometry.location.lat);
                setmapPostitionMarkerLang(place.geometry.location.lng);
                setMapAddress(place.formatted_address);
                sessionStorage.setItem("Curr_Loc", JSON.stringify(place.address_components))
                sessionStorage.setItem("Form_Add", JSON.stringify(place.formatted_address))
                // console.log(place); // Handle the selected place data
            });
        }

        // Load the Google Maps JavaScript API
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = initAutocomplete;
        document.head.appendChild(script);
    }, [apiKey]);

    return (
        <div className='places-search'>
            <input name="places-search" type='text' id="location-input" variant="solid" placeholder='search delivery location' lang="en" />
        </div>
    );
};

export default PlaceSearch;